import React, {Component} from 'react';
import {imageRoot} from '../../env.config';

class Image extends Component {
    render() {
        const { src, ...other } = this.props;
        return <img src={`${imageRoot}${src}`} {...other}/>;
    }
}


export default Image;
